export default __webpack_public_path__ + "static/media/Pharmacy_team_certificate.7142617b.png";